import React, { useMemo } from 'react';
import { Card, Table } from 'antd';
import ClipLoader from 'react-spinners/ClipLoader';
import { Line } from 'react-chartjs-2';
import { DiscoverFeedItemStats, DiscoverFeedStats } from '@models/statistics';
import { CHART_MISC_COLORS } from '@pages/Dashboard';

interface DiscoverFeedStatsCardsProps {
  data?: DiscoverFeedStats;
  isLoading: boolean;
}

const formatCtr = (value: number) => `${(value || 0).toFixed(1)}%`;

const itemColumns = [
  {
    title: '배너',
    dataIndex: 'title',
    render: (_: unknown, record: DiscoverFeedItemStats) => record.title || record.itemId,
  },
  {
    title: '노출',
    dataIndex: 'impressions',
    align: 'center' as const,
    width: 100,
    render: (value: number) => value?.toLocaleString?.() ?? value,
  },
  {
    title: '클릭',
    dataIndex: 'clicks',
    align: 'center' as const,
    width: 100,
    render: (value: number) => value?.toLocaleString?.() ?? value,
  },
  {
    title: 'CTR',
    dataIndex: 'ctr',
    align: 'center' as const,
    width: 90,
    render: (value: number) => formatCtr(value),
  },
];

export const DiscoverFeedStatsCards: React.FC<DiscoverFeedStatsCardsProps> = ({ data, isLoading }) => {
  const tabViewChart = useMemo(() => {
    const rows = data?.dailyTabViews || [];
    return {
      labels: rows.map((row) => row.date),
      datasets: [
        {
          label: '발견 탭 유입',
          data: rows.map((row) => row.count),
          borderColor: CHART_MISC_COLORS.view,
          backgroundColor: CHART_MISC_COLORS.view,
          tension: 0.2,
        },
      ],
    };
  }, [data?.dailyTabViews]);

  return (
    <>
      <Card className="chart" title="발견 탭 유입" bordered={false}>
        {isLoading && <ClipLoader />}
        {!isLoading && <Line data={tabViewChart} />}
      </Card>
      <Card className="chart" title="대배너 성과" bordered={false} style={{ maxWidth: 'calc(50% - 6px)' }}>
        {isLoading && <ClipLoader />}
        {!isLoading && (
          <Table
            size="small"
            pagination={false}
            bordered
            scroll={{ y: 240 }}
            rowKey={(record) => record.itemId}
            columns={itemColumns}
            dataSource={data?.banners || []}
          />
        )}
      </Card>
      <Card className="chart" title="미니배너 성과" bordered={false} style={{ maxWidth: 'calc(50% - 6px)' }}>
        {isLoading && <ClipLoader />}
        {!isLoading && (
          <Table
            size="small"
            pagination={false}
            bordered
            scroll={{ y: 240 }}
            rowKey={(record) => record.itemId}
            columns={itemColumns.map((col) => (col.title === '배너' ? { ...col, title: '숏컷' } : col))}
            dataSource={data?.shortcuts || []}
          />
        )}
      </Card>
    </>
  );
};

export default DiscoverFeedStatsCards;
